export default "__VITE_ASSET__DdA2to6$__"